/* Version: 3.5.149 */
'use client';
function animate(node, to) {
  var start = null;
  var from = node.scrollLeft;
  function step(timestamp) {
    if (start === null) {
      start = timestamp;
    }
    var time = Math.min(1, (timestamp - start) / 300);
    // eslint-disable-next-line no-param-reassign
    node.scrollLeft = time * (to - from) + from;
    if (time >= 1) {
      return;
    }
    requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// offset by 15 for tabs moving due to change in font-weight unless the tab is already bold because it is selected
function fontWeightOffset() {
  var isSelected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (isSelected) {
    return 0;
  }
  return 15;
}

export { animate, fontWeightOffset };
